export const profile = {
  profileFavoritesIconTitle: 'Favoriten',
  profileEditIconTitle: 'Bearbeiten',
  profileShareIconTitle: 'Teilen',
  profileAdditionalSectionTitle: 'Zusätzliche Infos',
  profileFavoritesCurtainTitle: 'Favoriten',
  profileFavoriteActionTitle: 'Zu Favoriten hinzufügen',
  profileFavoritedActionTitle: 'Zu Favoriten hinzugefügt',
  profileMessageAction: 'Nachricht',
  profileCurtainAdd: 'Hinzufügen',
  profileReportUser: 'Benutzer melden',
  profileReportTitle: 'Melden',
  profileReportSuccess: 'Inhalt gemeldet',
  profileReset: 'Zurücksetzen',
  profileApply: 'Anwenden',
  profileCustomInvalidEmail: 'ist keine gültige E-Mail-Adresse',
  profileMaxContentSizeError: 'Sie haben die maximale Inhaltsgröße überschritten!',
  profileMaxAvatarSizeError: 'Ihre Avatargröße ist zu groß!',
  profileFavoritesCurtainSearchInputText: 'Suchen',
  profileTapShareCurtainOptionTitle: 'Link kopieren',
  profileTapShareLinkCopiedAlertTitle: 'Link kopiert!',
  profileQrShareCurtainTitle: 'Profil teilen',
  profileQrShareCurtainShareButtonTitle: 'Teilen',
  profileQrShareCurtainCopyButtonTitle: 'Link kopieren',
  profileQrShareCurtainCopiedAlertTitle: 'Link kopiert!',
  profileQrTapShareProfileCurtainTitle: 'Teilen Sie Ihr Profil',
  profileEditTitle: 'Bearbeiten',
  profileEditPersonalSectionTitle: 'Persönliche Daten',
  profileEditContactsSectionTitle: 'Kontakte',
  profileEditSocialSectionTitle: 'Soziale Netzwerke',
  profileEditAddSocialButtonTitle: 'Soziale Medien hinzufügen',
  profileEditAdditionalSectionTitle: 'Zusätzliche Infos',
  profileEditSaveButtonTitle: 'Speichern',
  profileEditSavedAlertTitle: 'Profil gespeichert!',
  profileEditEmptyRequiredInputTitle: 'Wert darf nicht leer sein',
  profileEditEmptyRequiredEmailInputTitle: 'Öffentliche E-Mail ist keine gültige E-Mail-Adresse',
  profileEditEmptyRequiredErrorTitle: 'Etwas ist schief gelaufen!',
  profileEditSocialsHint: 'Bitte geben Sie die URL Ihres sozialen Profils ein',
  preferences: 'Einstellungen',
  interestedIn: 'Interessiert an',
  expertIn: 'Ich bin ein Experte in',
  myPitch: 'Mein Pitch',
  qrBadge: 'QR Badge',
  touchpoints: 'Touchpoints',
  lookingFor: 'Ich suche',
  topicsToDiscuss: 'Themen zu besprechen',
  createNew: 'Neues erstellen',
  viewTopic: 'Thema anzeigen',
  hobbyInterests: 'Hobbys & Interessen',
  myNetwork: 'Mein Netzwerk',
  seeAll: 'Alle ansehen',
  checkThemOut: 'Schau sie dir an!',
  activities: 'Aktivitäten',
  oneOnOne: '1:1 Treffen',
  Leaderboard: 'Rangliste',
  learnNetworking: 'Erfahren Sie mehr über Networking Hub',
  networkingGroup: 'Netzwerkgruppe',
  networkingLevel: 'Netzwerklevel',
  addNote: 'Notiz hinzufügen',
  notes: 'Notizen',
  enterNote: 'Notiz eingeben',
  shareUserProfile: 'Benutzerprofil teilen',
  flagUser: 'Benutzer melden'
}
